import React from "react";
import { CustomButton } from "../../../components";
import Breadcrumb from "../../../components/Breadcrumb";

import css from "../farm-details.module.css";

const FarmInfoBlock = ({ farm, onClick, btnRemove, canCrud }) => {
  const info = (
    <div className={css.contact}>
      <Breadcrumb account={farm} />
      {farm?.address && <p>{farm?.address}</p>}
    </div>
  );

  const btn = onClick ? (
    <CustomButton
      label="Edit farm details"
      onClick={() => onClick(farm)}
      color="secondary"
    />
  ) : null;

  const btns = (
    <div className={css.actions}>
      {btnRemove && btnRemove}
      {btn}
    </div>
  );

  return (
    <div className={css.info}>
      {info}
      {canCrud && btns}
    </div>
  );
};

export default FarmInfoBlock;
